// stores/useSessionStore.ts
import { create } from 'zustand';

import {
  getUserTokenInCookie,
  removeUserTokenFromCookie,
  saveUserTokenInCookie,
} from 'lib/helper';

// Define the state and actions types
type SessionStoreState = {
  session: string | undefined;
  setSession: (session: string) => void;
  clearSession: () => void;
};

// Initialize default session from cookies
const defaultSession = getUserTokenInCookie() || '';

// Create the store with default value from cookies
const useSessionStore = create<SessionStoreState>((set) => ({
  session: defaultSession,
  setSession: (session) => {
    set({ session });
    saveUserTokenInCookie(session);
  },
  clearSession: () => {
    removeUserTokenFromCookie();
    set({ session: undefined });
  },
}));

export { defaultSession, useSessionStore };
